import { BLOOMREACH_EVENT } from '../Constants/BloomreachConstants.js';
import { br_trackingEnabled } from './Bloomreach.js';

const br_checkout = (cart) => {
  if (!br_trackingEnabled() || !cart) return;
  let productList = [];
  if (cart.lineItems?.length > 0) {
    productList = cart.lineItems.map((item) => {
      return { id: item.key, quantity: item.quantity };
    });
  }
  exponea.track(BLOOMREACH_EVENT.CHECKOUT, {
    productList: productList,
  });
};

export { br_checkout };